import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const OrderSearchForm = ({ onSearch, isLoading }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const validatePhoneNumber = (phone) => {
    const digits = (phone || '').replace(/\D/g, '');
    return /^01\d{8,9}$/.test(digits);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setError('');

    if (!phoneNumber?.trim()) {
      setError('전화번호를 입력해주세요');
      return;
    }

    if (!validatePhoneNumber(phoneNumber)) {
      setError('올바른 전화번호 형식이 아닙니다 (예: 01012345678)');
      return;
    }

    onSearch(phoneNumber);
  };

  return (
    <div className="w-full rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl sm:p-8">
      <div className="mb-6 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Icon name="Search" size={32} color="var(--color-primary)" />
        </div>
        <h2 className="mb-2 text-2xl font-bold text-foreground">주문 조회</h2>
        <p className="text-sm text-muted-foreground">
          주문 시 입력하신 전화번호로 주문 상태를 확인하세요
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="tel"
          label="전화번호"
          placeholder="01012345678"
          value={phoneNumber}
          onChange={(e) => {
            const next = (e?.target?.value || '').replace(/\D/g, '');
            setPhoneNumber(next);
          }}
          error={error}
          required
          description="주문 시 입력하신 전화번호를 입력해주세요"
          className="bg-muted"
        />

        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          iconName="Search"
          iconPosition="left"
        >
          주문 조회하기
        </Button>
      </form>
      <div className="mt-6 rounded-lg bg-muted/50 p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="mt-0.5 text-primary" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">조회 안내</p>
            <ul className="mt-2 space-y-1 text-xs text-muted-foreground">
              <li>• 주문 시 입력한 전화번호로만 조회 가능합니다</li>
              <li>• 최근 6개월 이내 주문 내역을 확인할 수 있습니다</li>
              <li>• 문의사항은 고객센터로 연락주세요</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSearchForm;